// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__Z-F4o","child2":"styles_child2__F7tam","parent":"styles_parent__JSSho"};